"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
const useIconScreenReaderAccessProps_1 = __importDefault(require("../../../hooks/useIconScreenReaderAccessProps"));
function modifySvgCode(svg, color = "currentColor") {
    return svg.replace(/fill=".*?"/g, `fill="${color}"`);
}
const CustomSvgIcon = ({ className, ref, src, onClick, clickable, ariaLabel, ariaHidden, replaceToCurrentColor = false, customColor, "data-testid": dataTestId }) => {
    const screenReaderAccessProps = (0, useIconScreenReaderAccessProps_1.default)({
        isClickable: clickable,
        label: ariaLabel,
        isDecorationOnly: ariaHidden
    });
    const svgProcessor = (0, react_1.useCallback)((svg) => {
        if (replaceToCurrentColor)
            return modifySvgCode(svg, "currentColor");
        if (customColor)
            return modifySvgCode(svg, customColor);
        return svg;
    }, [replaceToCurrentColor, customColor]);
    if (typeof src !== "string")
        return null;
    return ((0, jsx_runtime_1.jsx)(react_inlinesvg_1.default, Object.assign({ innerRef: ref }, screenReaderAccessProps, { onClick: onClick, src: src, className: (0, classnames_1.default)("monday-style-custom-svg-icon--wrapper", className), preProcessor: svgProcessor, "data-testid": dataTestId })));
};
exports.default = CustomSvgIcon;
